// extracted by mini-css-extract-plugin
module.exports = {"increase":"Currency_increase__3PnZ8","decrease":"Currency_decrease__3wO55"};